// ImageGallery.jsx
import React, { useState } from "react";
import { GalleryImage } from "./GalleryImage";

const galleryImages = [
  {
    src: "https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/22480d6dffee37b953eb8dea3f978ad222a2342df52e2820a7941fb78190ae58?apiKey=9804d3a088fa478e8672485264720a14",
    hoverSrc: "https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/5b24c8d34f73e064053996abe0822e72e9f54db412af98c1053a96259031e21a?apiKey=9804d3a088fa478e8672485264720a14"
  },
  {
    src: "https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/d7e07fae9ee164806f28e63adeca0cb78745d94a37e026d300f70635db2a07f4?apiKey=9804d3a088fa478e8672485264720a14",
    hoverSrc: "https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/2a0ee10e29a4eddb8a7a255144e486d4023c98c23b7d7c17ab829694c58955ee?apiKey=9804d3a088fa478e8672485264720a14"
  },
  {
    src: "https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/19b8c76a3d3af5fcce9df47df4a8fba360541a6c6fd78582fbf45df08982c424?apiKey=9804d3a088fa478e8672485264720a14",
    hoverSrc: "https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/4010c5cf1e1ffaf3c220ff80e187a194a20e3dfc24bf294b3d3ff30d2635d0eb?apiKey=9804d3a088fa478e8672485264720a14"
  }
];

export function ImageGallery() {
  const [hovered, setHovered] = useState(null); // индекс

  return (
    <div className="grid grid-cols-3 gap-2 w-full max-md:grid-cols-2 max-sm:grid-cols-1 mb-[100px]">
      {galleryImages.map((image, index) => {
        const isHovered = hovered === index;

        return (
          <div
            key={index}
            className={`relative w-full aspect-[4/5] group ${
              index === 1 ? "max-sm:p-20" : ""
            }`}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
            // Mobile-д hover байхгүй тул click-д бас асааж болно:
            onTouchStart={() => setHovered(index)}
          >
            {/* Гол зураг (үргэлж харагдана) */}
            <GalleryImage
              src={image.src}
              className="object-cover w-full h-full"
              alt={`Gallery image ${index + 1}`}
              // Дээд талын мөрөнд байгаа 1-2 зургийг priority=true болгох боломжтой
              priority={index < 2}
              sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
            />

            {/* Hover зураг — ХЭЗЭЭ ч эхэндээ татахгүй. Hover үед л render → татна */}
            {isHovered && (
              <div className="absolute inset-0 transition-opacity duration-300">
                <GalleryImage
                  src={image.hoverSrc}
                  className="object-cover w-full h-full"
                  alt={`Gallery hover image ${index + 1}`}
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
